import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import store from '@/store/';
import routesAdmin from '@/router/routes-admin';
import routesCore from '@/router/routes-core';
import routesLocalAuth from '@/router/routes-localAuth';
import routesOauthAuth from '@/router/routes-oauthAuth';
import App from '@/App';

const AdminWrapper = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/AdminWrapper');

Vue.use(Router);

const authRoutes = config.features.localAuth ? routesLocalAuth : routesOauthAuth;

const router = new Router({
  mode: 'history',
  routes: [
    ...authRoutes.root,
    {
      path: '',
      component: App,
      children: [
        ...routesCore,
        ...authRoutes.core,
        {
          path: '/admin',
          component: AdminWrapper,
          name: 'AdminWrapper',
          beforeEnter(to, from, next) {
            if (store.getters.user && !store.getters.isUserAdmin) {
              // TODO show alert
              next({ name: 'NotFound' });
              return;
            }

            next();
          },
          children: [...routesAdmin, ...authRoutes.admin],
        },
      ],
      meta: { publicRoute: true },
    },
    {
      path: '*',
      name: 'NotFound',
      redirect: { name: '404View' },
    },
  ],
});

export default router;
